export const OPEN = '1983C67086D';
export const FINISHED = '1983C6726B8';

export default {
  open: OPEN,
  finished: FINISHED,
};
